module.exports = __webpack_public_path__ + "static/media/pexels-olya-kobruseva-6507004.596d4eb9.jpg";